module.exports = __webpack_public_path__ + "img/DarkModeOutlined.7c1325a3.svg";